import { createActionNamespace } from 'Modules/core/redux';

import { IParameters, IQueue, IRequest, IReceive, IDirtyByType } from './types';


const paginationAction = createActionNamespace('pagination');

export const paginationActions = {
    setParameters: paginationAction.withPath<IParameters>('SET_PARAMETERS'),
    setParametersThrottled: paginationAction.withPath<IParameters>('SET_PARAMETERS_THROTTLED'),
    setQueue: paginationAction.withPath<IQueue>('SET_QUEUE'),
    setTotal: paginationAction.withPath<number>('SET_TOTAL'),
    markDirty: paginationAction.withPath<boolean>('MARK_DIRTY'),
    request: paginationAction.withPath<IRequest>('REQUEST'),
    requestRefresh: paginationAction.withPath<IRequest>('REQUEST_REFRESH'),
    linkQueue: paginationAction.withPath<IRequest>('LINK_QUEUE'),
    receive: paginationAction.withPath<IReceive>('RECEIVE'),
    receiveRefresh: paginationAction.withPath<IReceive>('RECEIVE_REFRESH'),
    massMarkDirty: paginationAction<string>('MASS_MARK_DIRTY'),
    markDirtyByType: paginationAction<IDirtyByType>('MARK_DIRTY_BY_TYPE'),
    setError: paginationAction.withPath<string>('SET_ERROR'),
    refresh: paginationAction.withPath<{}>('REFRESH'),
    reducerRefresh: paginationAction.withPath<{}>('REDUCER_REFRESH'),
    massRefresh: paginationAction<string>('MASS_REFRESH'),
};
